import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { LearningResourcesRoutingModule } from './learning-resources-routing.module';
import { LearningResourcesListComponent } from './learning-resources-list/learning-resources-list.component';
import { LearningResourcesCreateComponent } from './learning-resources-create/learning-resources-create.component';

@NgModule({
  declarations: [LearningResourcesListComponent, LearningResourcesCreateComponent],
  imports: [
    CommonModule,
    LearningResourcesRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class LearningResourcesModule { }
